// extracted by mini-css-extract-plugin
export var root = "n_Z";
export var grid = "n_bH";
export var logo = "n_t";
export var heading = "n_G";
export var asterisk = "n_bJ";
export var desc = "n_H";